var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.THE_CLIENT)?_c('div',{staticClass:"share-box",style:({'top':_vm.position.top,'right':_vm.position.right}),on:{"click":_vm.goShare}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }